export default defineNuxtPlugin((nuxtApp) => {
  const AUTH_GUARD_DISABLED = false;
  
  if (AUTH_GUARD_DISABLED) {
    console.log('[AUTH-GUARD] Plugin is temporarily disabled for debugging');
    return;
  }
  
  // Add a global navigation hook that runs before the router navigation
  nuxtApp.hook('page:start', async () => {
    // console.log('[AUTH-GUARD] Page navigation started, refreshing auth state')
    const { forceUpdateAuthState, isAuthenticated } = useAuth()
    
    // Get current route
    const route = useRoute()
/*    console.log('[AUTH-GUARD] Current route:', {
      path: route.path,
      fullPath: route.fullPath,
      name: route.name,
      query: JSON.stringify(route.query)
    })*/
    
    // Force update auth state on each navigation
    await forceUpdateAuthState()
    
    // Log the result for debugging
 /*   console.log('[AUTH-GUARD] Auth state after navigation start:', {
      isLoggedIn: isAuthenticated.value,
      currentPath: route.path
    })*/
  })
  
  // Also add a hook that runs after navigation completes
/*  nuxtApp.hook('page:finish', () => {
    const route = useRoute()
    console.log('[AUTH-GUARD] Page navigation finished', {
      path: route.path,
      fullPath: route.fullPath
    })
  })*/
}) 